/* =========================================================
   K.NOAH — QUOTE MAIL BRIDGE V3

   Desktop quote submission with:
   - Cloudinary Jersey / Pants preview links
   - Detailed configurator data
   - Normal Shopify form submission
   - Shopify CAPTCHA preserved

   DOES NOT modify:
   - Configurator
   - kn-quote-page.js
   - kn-quote-data.js
   - kn-quote-preview-link.js
   - kn-export.js
   ========================================================= */

(function () {
  'use strict';

  if (window.KNOAH_QUOTE_MAIL_BRIDGE_V3) {
    return;
  }

  window.KNOAH_QUOTE_MAIL_BRIDGE_V3 = true;


  /* =========================================================
     HELPERS
     ========================================================= */

  function clean(value) {
    return String(
      value == null ? '' : value
    ).trim();
  }


  function getValue(form, selector) {
    var node = form.querySelector(selector);

    return node
      ? clean(node.value)
      : '';
  }


  function getProduct(form) {
    var product =
      form.querySelector(
        'input[name="knq-product"]:checked'
      );

    return product
      ? clean(product.value)
      : 'Full Uniform';
  }


  /* =========================================================
     PRODUCT LOGIC
     ========================================================= */

  function wantsJersey(product) {
    var value =
      clean(product)
        .toLowerCase()
        .trim();

    if (
      value === 'pants' ||
      value === 'pants only'
    ) {
      return false;
    }

    return true;
  }


  function wantsPants(product) {
    var value =
      clean(product)
        .toLowerCase()
        .trim();

    if (
      value === 'jersey' ||
      value === 'jerseys' ||
      value === 'jersey only' ||
      value === 'jerseys only'
    ) {
      return false;
    }

    return true;
  }


  /* =========================================================
     CONFIGURATOR DATA
     ========================================================= */

  function getConfiguratorData() {

    if (
      !window.KNoahQuoteData ||
      typeof window.KNoahQuoteData.toText !== 'function'
    ) {
      return (
        'CONFIGURATION DATA UNAVAILABLE\n' +
        'kn-quote-data.js was not available.'
      );
    }


    try {

      return (
        window.KNoahQuoteData.toText() ||
        'CONFIGURATION DATA UNAVAILABLE'
      );

    } catch (error) {

      console.error(
        'K.NOAH Quote Data Error:',
        error
      );

      return (
        'CONFIGURATION DATA UNAVAILABLE\n' +
        'Could not read configurator data.'
      );
    }
  }


  /* =========================================================
     PREVIEW GENERATION
     ========================================================= */

  async function createPreviewLinks(product) {

    var previews = {
      jersey: '',
      pants: ''
    };


    if (!window.KNoahQuotePreview) {

      console.error(
        'K.NOAH Quote Preview API unavailable.'
      );

      return previews;
    }


    /* JERSEY */

    if (
      wantsJersey(product) &&
      typeof window.KNoahQuotePreview.createJersey ===
        'function'
    ) {

      try {

        console.log(
          'K.NOAH QUOTE — creating Jersey preview...'
        );

        var jersey =
          await window.KNoahQuotePreview.createJersey();

        if (
          jersey &&
          jersey.url
        ) {
          previews.jersey =
            jersey.url;
        }

      } catch (error) {

        console.error(
          'K.NOAH Jersey Preview Error:',
          error
        );
      }
    }


    /* PANTS */

    if (
      wantsPants(product) &&
      typeof window.KNoahQuotePreview.createPants ===
        'function'
    ) {

      try {

        console.log(
          'K.NOAH QUOTE — creating Pants preview...'
        );

        var pants =
          await window.KNoahQuotePreview.createPants();

        if (
          pants &&
          pants.url
        ) {
          previews.pants =
            pants.url;
        }

      } catch (error) {

        console.error(
          'K.NOAH Pants Preview Error:',
          error
        );
      }
    }


    return previews;
  }


  /* =========================================================
     BUILD FINAL EMAIL
     ========================================================= */

  function buildDetailedMessage(
    form,
    previews
  ) {

    previews =
      previews || {
        jersey: '',
        pants: ''
      };


    var product =
      getProduct(form);

    var output = [];


    /* HEADER */

    output.push(
      'K.NOAH — NEW UNIFORM QUOTE REQUEST'
    );

    output.push('');
    output.push(
      '========================================'
    );


    /* CUSTOMER */

    output.push('');
    output.push('CUSTOMER');

    output.push(
      '----------------------------------------'
    );

    output.push(
      'Name: ' +
      getValue(form, '#knq-name')
    );

    output.push(
      'Team / Organization: ' +
      getValue(form, '#knq-team')
    );

    output.push(
      'Email: ' +
      getValue(form, '#knq-email')
    );

    output.push(
      'Phone: ' +
      getValue(form, '#knq-phone')
    );


    /* REQUEST */

    output.push('');
    output.push('REQUEST');

    output.push(
      '----------------------------------------'
    );

    output.push(
      'Product: ' +
      product
    );

    output.push(
      'Quantity: ' +
      getValue(form, '#knq-quantity')
    );


    /* DESIGN PREVIEW */

    output.push('');
    output.push('');
    output.push(
      'DESIGN PREVIEW'
    );

    output.push(
      '----------------------------------------'
    );


    if (previews.jersey) {

      output.push(
        'Jersey: ' +
        previews.jersey
      );
    }


    if (previews.pants) {

      output.push(
        'Pants: ' +
        previews.pants
      );
    }


    if (
      !previews.jersey &&
      !previews.pants
    ) {

      output.push(
        'Preview unavailable.'
      );
    }


    /* CONFIGURATION */

    var config =
      getConfiguratorData();


    if (config) {

      output.push('');
      output.push('');
      output.push(config);
    }


    /* MESSAGE */

    output.push('');
    output.push('');
    output.push(
      'MESSAGE / NOTES'
    );

    output.push(
      '----------------------------------------'
    );

    output.push(
      getValue(
        form,
        '#knq-message'
      ) || '—'
    );


    /* FOOTER */

    output.push('');
    output.push('');

    output.push(
      '========================================'
    );

    output.push(
      'Sent via K.NOAH Uniform Configurator.'
    );


    return output.join('\n');
  }


  /* =========================================================
     BUTTON
     ========================================================= */

  function setSubmittingState(
    form,
    active
  ) {

    var button =
      form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );


    if (!button) {
      return;
    }


    if (active) {

      if (
        !button.dataset.knOriginalText
      ) {

        button.dataset.knOriginalText =
          button.tagName.toLowerCase() === 'input'
            ? button.value
            : button.innerHTML;
      }


      button.disabled = true;


      if (
        button.tagName.toLowerCase() ===
          'input'
      ) {

        button.value =
          'CREATING DESIGN...';

      } else {

        button.innerHTML =
          '<span>CREATING DESIGN...</span>';
      }

    } else {

      button.disabled = false;


      if (
        button.dataset.knOriginalText
      ) {

        if (
          button.tagName.toLowerCase() ===
            'input'
        ) {

          button.value =
            button.dataset.knOriginalText;

        } else {

          button.innerHTML =
            button.dataset.knOriginalText;
        }
      }
    }
  }


  /* =========================================================
     IMPORTANT:
     FINAL BODY PROTECTION

     kn-quote-page.js has its own normal submit listener.

     On the second submit:
     1. Its listener may overwrite #knq-body.
     2. This listener runs afterwards.
     3. We restore our final body.
     4. We DO NOT prevent the native Shopify submit.

     This preserves Shopify CAPTCHA.
     ========================================================= */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;


      if (
        !form ||
        form.id !== 'knq-form'
      ) {
        return;
      }


      if (
        form.dataset.knQuoteReady !== '1'
      ) {
        return;
      }


      var body =
        form.querySelector(
          '#knq-body'
        );


      if (
        body &&
        form.__knFinalQuoteBody
      ) {

        body.value =
          form.__knFinalQuoteBody;


        console.log(
          'K.NOAH QUOTE — final body restored before Shopify submit.'
        );
      }


      /*
        IMPORTANT:
        NO preventDefault()
        NO stopPropagation()
        NO direct form.submit()

        Shopify continues normally,
        including CAPTCHA.
      */

    },
    false
  );


  /* =========================================================
     FIRST SUBMIT — PREPARE QUOTE

     Capture phase means we stop the FIRST submission before
     kn-quote-page.js can send it.

     After previews are ready we call requestSubmit().
     That second submission is allowed through normally.
     ========================================================= */

  document.addEventListener(
    'submit',
    async function (event) {

      var form =
        event.target;


      if (
        !form ||
        form.id !== 'knq-form'
      ) {
        return;
      }


      /*
        SECOND PASS

        Preview generation already finished.
        Do not block Shopify.
      */

      if (
        form.dataset.knQuoteReady === '1'
      ) {
        return;
      }


      /*
        FIRST PASS
      */

      event.preventDefault();
      event.stopImmediatePropagation();


      if (
        form.dataset.knQuoteProcessing === '1'
      ) {
        return;
      }


      if (
        !form.checkValidity()
      ) {

        form.reportValidity();
        return;
      }


      form.dataset.knQuoteProcessing =
        '1';


      setSubmittingState(
        form,
        true
      );


      var body =
        form.querySelector(
          '#knq-body'
        );


      if (!body) {

        console.error(
          'K.NOAH QUOTE: #knq-body not found.'
        );

        form.dataset.knQuoteProcessing =
          '0';

        setSubmittingState(
          form,
          false
        );

        return;
      }


      try {

        var product =
          getProduct(form);


        /* 1. PREVIEWS */

        var previews =
          await createPreviewLinks(
            product
          );


        /* 2. FINAL EMAIL */

        var detailed =
          buildDetailedMessage(
            form,
            previews
          );


        /*
          Store the final message separately.

          Even if kn-quote-page.js overwrites
          #knq-body on the second submit,
          we can restore this exact version.
        */

        form.__knFinalQuoteBody =
          detailed;


        body.value =
          detailed;


        /* 3. SECOND PASS */

        form.dataset.knQuoteReady =
          '1';

        form.dataset.knQuoteProcessing =
          '0';


        console.log(
          'K.NOAH QUOTE — previews ready:',
          previews
        );


        console.log(
          'K.NOAH QUOTE — starting normal Shopify submission...'
        );


        /*
          IMPORTANT:
          requestSubmit() keeps Shopify's normal
          submission / CAPTCHA mechanism.
        */

        form.requestSubmit();


      } catch (error) {

        console.error(
          'K.NOAH Quote Submit Error:',
          error
        );


        form.dataset.knQuoteProcessing =
          '0';

        form.dataset.knQuoteReady =
          '0';

        form.__knFinalQuoteBody =
          '';


        setSubmittingState(
          form,
          false
        );


        alert(
          'The quote request could not be prepared. Please try again.'
        );
      }

    },
    true
  );


  /* =========================================================
     DEBUG API
     ========================================================= */

  window.KNoahQuoteMail = {

    preview: function () {

      var form =
        document.getElementById(
          'knq-form'
        );


      if (!form) {
        return '';
      }


      return buildDetailedMessage(
        form,
        {
          jersey:
            'JERSEY PREVIEW URL',

          pants:
            'PANTS PREVIEW URL'
        }
      );
    },


    createPreviews:
      async function () {

        var form =
          document.getElementById(
            'knq-form'
          );


        if (!form) {

          throw new Error(
            'Quote form not found.'
          );
        }


        return await createPreviewLinks(
          getProduct(form)
        );
      }

  };


  console.log(
    'K.NOAH Quote Mail Bridge V3 loaded.'
  );

})();